import React, { useEffect, useRef, useState } from 'react';
import styles from './ProductCarousel.module.scss';
import BaseCarousel from '../../../../commons/components/ui/BaseCarousel/BaseCarousel';
import { pillFive, pillTwo } from '../../../../src/images';
import { Typography } from '@mui/material';
import Image from 'next/image';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { ContainedButton } from '../../../../commons/hoc';
import { useRouter } from 'next/router';
import { productUpsellCarousel } from '../../../../commons/Constants';
import useMediaQuery from '@mui/material/useMediaQuery';

const ArrowButton = ({ children, clickCB }) => {
  return (
    <div className={styles.paginationButton} onClick={clickCB}>
      {children}
    </div>
  );
};

export default function ProductCarousel() {
  const router = useRouter();
  const baseCarouselRef = useRef(null);
  const [currentSlideIdx, setCurrentSlideIdx] = useState(40);
  const [showAnim, setShowAnim] = useState(null);
  const isMobile = !useMediaQuery('(max-width:578px)');

  const convertedItems = Array(20).fill(productUpsellCarousel).flat();

  useEffect(() => {
    setTimeout(() => {
      setShowAnim(false);
    }, 250);
  }, [showAnim]);

  const handleSlideChange = (index) => {
    setCurrentSlideIdx(index);
    setShowAnim(true);
  };

  const next = () => {
    if (baseCarouselRef.current) {
      baseCarouselRef.current.handleNext();
      setShowAnim(true);
    }
  };
  const prev = () => {
    if (baseCarouselRef.current) {
      baseCarouselRef.current.handlePrev();
    }
  };

  const onSlideClick = (itemId) => {
    if (baseCarouselRef?.current?.currentSlide === itemId) {
      router.push(
        {
          pathname: convertedItems[currentSlideIdx].link,
        },
        undefined
      );
    }
  };

  const ProductCard = ({ item, activeId }) => {
    return (
      <div className={styles.productCardWrapper}>
        <div
          className={styles.productCardContainer}
          style={{ pointerEvents: item.id === activeId ? 'all' : 'none' }}
          onClick={() => onSlideClick(item.id)}
        >
          <div className={styles.imgContainer}>
            {/* Keep below code as it is for future use */}
            {/* <div className={styles.imgPillOne}>
              <div className={styles.imgPillContainer}>
                <Image src={pillTwo} layout="fill" className={styles.img} />
              </div>
            </div> */}
            <div className={styles.mainProductImg}>
              <Image
                src={item.productImg}
                layout="fill"
                className={styles.img}
              />
            </div>
            {/* Keep below code as it is for future use */}
            {/* <div className={styles.imgPillTwo}>
              <div className={styles.imgPillFiveContainer}>
                <Image src={pillFive} layout="fill" className={styles.img} />
              </div>
            </div> */}
          </div>
          <div
            className={styles.productCategory}
            style={{ opacity: item.id == activeId ? 1 : 0.2 }}
          >
            <Typography
              variant="h1"
              color="primary"
              className={styles.productCategoryTitle}
            >
              {item.category}
            </Typography>
          </div>
        </div>
      </div>
    );
  };

  const slides = convertedItems.map((item) => {
    return {
      key: item.id,
      component: (
        <ProductCard
          item={item}
          activeId={convertedItems[currentSlideIdx].id}
        />
      ),
    };
  });

  return (
    <div className={`${styles.carouselWrapper}`}>
      <div
        className={`${styles.carouselBgGraident}  ${
          showAnim ? styles.fadeOut : styles.fadeIn
        }`}
        style={{
          backgroundImage: `linear-gradient(${convertedItems[currentSlideIdx]?.gradient}, #fff)`,
        }}
      ></div>
      <div className={styles.carouselContainer}>
        <div className={styles.carouselTitle}>
          <Typography variant="h3" color="primary">
            Experience the It Factor
          </Typography>
        </div>
        <div className={styles.carouselMainContent}>
          <BaseCarousel
            handleSlideChange={handleSlideChange}
            ref={baseCarouselRef}
            items={slides}
            options={getConfigurableProps(isMobile, onSlideClick)}
            currentIdx={currentSlideIdx}
          />
        </div>
        <div className={`${styles.productName}`}>
          <Typography variant="h2" color="primary">
            {convertedItems[currentSlideIdx].productName}
          </Typography>
        </div>
        <div className={styles.carouselNavigation}>
          <div>
            <ArrowButton clickCB={prev}>
              <ArrowBackIcon className={styles.arrowIcon} />
            </ArrowButton>
          </div>
          <div className={styles.mainShopBtn}>
            <ContainedButton
              btnType="dark"
              arrow={true}
              onClick={() => {
                router.push(
                  {
                    pathname: convertedItems[currentSlideIdx].link,
                  },
                  undefined
                );
              }}
              className={styles.shopBtn}
            >
              Shop Now
            </ContainedButton>
          </div>
          <div>
            <ArrowButton clickCB={next}>
              <ArrowForwardIcon className={styles.arrowIcon} />
            </ArrowButton>
          </div>
        </div>
      </div>
    </div>
  );
}
const getConfigurableProps = (isMobile, onSlideClick) => ({
  showArrows: false,
  showStatus: false,
  showIndicators: false,
  infiniteLoop: true,
  showThumbs: false,
  useKeyboardArrows: true,
  stopOnHover: true,
  swipeable: false,
  emulateTouch: true,
  autoFocus: false,
  thumbWidth: 100,
  centerMode: isMobile,
  interval: 2000,
  transitionTime: 500,
  swipeScrollTolerance: 5,
  centerSlidePercentage: 50,
  onClickItem: onSlideClick,
});
